/*
 * @Author: ken yang
 * @Date: 2023-04-12 14:48:52
 * @LastEditTime: 2023-04-13 16:14:33
 * @LastEditors: ken yang
 * @Description: 封装单例js
 * @FilePath: /uexch_admin/src/components/dialog/DiaGoogleVer.js
 */

const DiaSingle = async (props) => {
  const mountNode = document.createElement('div')
  return new Promise(async (resolve, reject) => {
    try {
      const { app, router } = await BiCreateApp(props.com, mountNode, {
        ...props,
        close: () => {
          app.unmount(mountNode)
          document.body?.removeChild(mountNode)
        }
      })
      document.body?.appendChild(mountNode)
      resolve()
    } catch (error) {
      reject()
    }
  })
}

export default DiaSingle

